// Real content from https://www.seotechexperts.in/testserver/tes/
// Nothing fabricated. Empty fields stay empty.

export const COMPANY = {
  name: 'Tricolite Energy Solutions',
  legal: 'M/s Tricolite Energy Solutions Pvt. Ltd.',
  parent: 'M/s Tricolite Electrical Industries Limited',
  group: 'Trilok Chand Group',
  foundedEpc: 2012,
  parentSince: 1989,
  groupSince: '1920s',
  scale: '720 MINR+',
  email: 'solutions@tricoliteenergy.in',
  phonePrimary: '+91 124-2841155',
  phoneTel: '+911242841155',
  whatsapp: 'https://wa.me/919810608151',
  whatsappDisplay: '+91 98106-08151',
  linkedin: 'https://www.linkedin.com/company/tricolite-energy-solutions/',
  certifications: ['ISO 9001', 'ISO 14001', 'ISO 45001'],
};

export const HERO_SLIDES = [
  {
    eyebrow: 'EPC Solutions',
    title: 'Affordable, Clean & Efficient',
    accent: 'Energy Solutions',
    desc: 'End-to-end Electrical & Solar EPC services delivered with a human-centred design approach.',
  },
  {
    eyebrow: 'Smart Energy',
    title: 'Driving Smart Energy Solutions',
    accent: 'by Unlocking Efficiency',
    desc: 'Energy audits, IoT & M2M monitoring, and efficiency projects that reduce consumption and cost.',
  },
  {
    eyebrow: 'Renewables',
    title: 'Shaping a Sustainable Future',
    accent: 'with Solar Power',
    desc: 'Rooftop and ground-mounted solar EPC — designed, engineered and commissioned in-house.',
  },
];

export const STATS = [
  { value: '370', suffix: 'MVA', label: 'Electrical substations commissioned' },
  { value: '1', suffix: 'MWp', label: 'Solar Rooftops' },
  { value: '720', suffix: 'MINR+', label: 'Technology-oriented company scale' },
  { value: '2012', suffix: '', label: 'EPC arm established' },
];

export const FOCUS_AREAS = [
  'GIS and AIS Substation',
  'Industry & Building High Side Works',
  'Solar Rooftop Installations',
  'Energy Audits',
  'Energy Efficiency Solutions through IoT',
];

export const WHY_TES = [
  {
    title: 'Pre Order Project Engineering',
    body: 'A critical phase where our electrical EPC team lays the foundation for successful project execution. This stage involves a detailed study of drawings and specifications, combined with thorough site visits to understand actual site conditions. Based on these insights, we carry out technical evaluations, identify potential challenges, and prepare a clear execution plan. Manpower deployment, material requirements, timelines, and safety considerations are all planned in advance, ensuring smooth mobilisation once the project begins. This meticulous pre-planning helps minimise risks, optimise resources, and deliver projects efficiently, safely, and on schedule.',
    num: '01',
  },
  {
    title: 'Project Planning, Procurement & Construction',
    body: 'The backbone of our EPC execution process. During this phase, we prepare detailed day-wise and week-wise schedules for procurement and construction, ensuring seamless coordination and timely execution. All activities are carried out in line with ISO-standard formats and Total Quality Management (TQM) principles, focusing on quality, safety, and continuous improvement. Regular monitoring, documentation, and reviews ensure clear communication and transparency with the client at every stage. This structured approach enables effective resource utilisation, quality-controlled execution, and complete project closure with assured client satisfaction.',
    num: '02',
  },
  {
    title: 'Brown Field Project — AMC, Retrofit & Modifications',
    body: 'Strengthening and modernising existing electrical and energy infrastructure. We actively undertake Annual Maintenance Contracts (AMC), retrofit assignments, and modification projects to upgrade old sites and bring them to higher standards of efficiency, reliability, and safety. Our team evaluates existing systems, identifies improvement opportunities, and implements solutions that optimise energy usage, integrate solar where feasible, and enhance the performance of running units. We have successfully worked with reputed clients such as Maruti Suzuki on such projects. With a strong focus on re-engineering and upgradation, think of us when you think of rework, efficiency improvement, and smarter energy solutions.',
    num: '03',
  },
];

export const SOLUTIONS = [
  {
    title: 'Affordable Transmission and Distribution',
    items: [
      'Transmission Lines up to 132 kV',
      'Switchyards Works up to 132 kV',
      'Cable Laying up to 132 kV',
      'Building High Side Work',
      'LT/HT substations',
    ],
  },
  {
    title: 'Clean Solar',
    items: [
      'Solar Rooftops',
      'Ground Mounted Solar EPC (AC + DC)',
    ],
  },
  {
    title: 'Efficient Energy',
    items: [
      'Energy Audits',
      'Energy Saving Projects',
      'Online Monitoring of Energy',
      'Energy control through use of IoT & sensors',
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: 'Mr. Ashok Kumar',
    role: 'AGM – Estate Management',
    company: 'DS Group',
    photo: '/clients/ashok-photo.webp',
    quote: 'We at DS Group, are pleased to acknowledge the excellent work carried out by Tricolite Energy, Gurgaon at our site B-02, Ecotech Extension One, Greater Noida. They successfully executed the electrical high-side and low-side works, including the installation of a 3 MVA transformer, as well as the electrical low-side works at our facility. Their team demonstrated professionalism, technical expertise, and commitment to timely project completion. We highly recommend Tricolite Energy for any complex electrical installations and related services.',
  },
  {
    name: 'Mr. R Selva',
    role: 'GM Operations',
    company: 'MASU Brakes',
    photo: '/clients/selva-photo.webp',
    quote: 'The entire electrical works executed in stipulated time with excellent quality and workmanship. The firm consists of highly professional and experienced management together with a dedicated and skilled site team. They are capable of undertaking larger EPC electrical works. The entire works were executed in 65,000 safe man-hours with zero quality defects. It was a pleasure working with them. We wish M/s Tricolite Energy Solutions all the very best.',
  },
];

export const NAV = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'What We Do', path: '/services' },
  { label: 'Our Work', path: '/our-work' },
  { label: 'CSR', path: '/csr' },
  { label: 'Careers', path: '/careers' },
  { label: 'Become a Subcontractor', path: '/subcontractors' },
  { label: 'Contact', path: '/contact' },
];
